import { Link } from 'react-router-dom';
import { Tooltip, Avatar } from 'antd';
import QuoteStore from '../../stores/QuoteStore';
import { ShoppingCartOutlined } from '@ant-design/icons';
import React from 'react';
import { observer } from 'mobx-react-lite';

const CartIconHeader = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link
                to="/my-account/parts/cart/"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: '80px',
                }}
            >
                <Tooltip title="View your cart">
                    <ShoppingCartOutlined style={{ fontSize: '2rem' }} />
                </Tooltip>

                {QuoteStore.selectedLineItems?.length ? (
                    <Avatar
                        size={24}
                        style={{
                            backgroundColor: '#c00',
                            color: '#fff',
                            fontSize: '14px',
                            marginLeft: '6px',
                        }}
                    >
                        {QuoteStore.selectedLineItems?.length ?? 0}
                    </Avatar>
                ) : null}

                <span
                    style={{
                        lineHeight: '14px',
                        marginLeft: '10px',
                    }}
                >
                    Cart
                </span>
            </Link>
        </div>
    );
};

export default observer(CartIconHeader);
